module.exports = __webpack_public_path__ + "static/data-inset-photo-986686cfa9ddeece0057857d9a90de46.jpg";